import { pm2InterfaceStore } from '@pm2/store';
import { hasMegaMenu } from './descriptor.has-megamenu.js';
import { openMegaMenu } from './megamenu.open.js';
import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';
import { getNestedPages } from './util.get-nested-pages.js';

async function openMegaMenuAtBreadcrumb(configStore, sitemapStore, targetDescriptor, { isMobile }) {
  if (hasMegaMenu(targetDescriptor)) {
    await openMegaMenu(configStore, sitemapStore, targetDescriptor, {
      isMobile
    });
    return;
  }
  const descriptors = [targetDescriptor];
  let currentDescriptor = descriptors[descriptors.length - 1];
  while (currentDescriptor == null ? void 0 : currentDescriptor.parentId) {
    const parentDescriptor = findPageDescriptorById(
      sitemapStore.getState(),
      currentDescriptor.parentId
    );
    if (parentDescriptor) {
      descriptors.push(parentDescriptor);
      currentDescriptor = parentDescriptor;
    } else {
      currentDescriptor = void 0;
    }
  }
  descriptors.reverse();
  pm2InterfaceStore.dispatch(
    pm2InterfaceStore.actions.setPendingMegaMenu(descriptors[0].id)
  );
  await Promise.all(
    descriptors.map(
      (descriptor) => getNestedPages(configStore, sitemapStore, descriptor)
    )
  );
  pm2InterfaceStore.dispatch(
    pm2InterfaceStore.actions.setMegaMenu(descriptors.map((it) => it.id))
  );
}

export { openMegaMenuAtBreadcrumb };
//# sourceMappingURL=megamenu.open-at-breadcrumb.js.map
